// import Nfse from './Index.vue'
import Permissions from "../../models/Permissions";

const Nfse = () => import("./Index.vue");

const permissions = [
  Permissions.COLABORADOR,
  Permissions.GESTOR,
  Permissions.ADMINISTRADOR,
];

const meta = {
  requiresAuth: true,
  requiresCompany: true,
  showInMenu: true,
  label: "NFSe",
  icon: "fa fa-files-o",
  group: "Arquivos",
  permissions,
};

export default [
  {
    path: "/nfse",
    name: "Nfse",
    component: Nfse,
    meta,
  },
];
